import { useContext } from "react";
import { ConfiguracionInicialContext } from "../Contexts/ConfiguracionInicialContext";

export const useConfiguracionInicial = () => {
  const contexto = useContext(ConfiguracionInicialContext);
  if (!contexto) {
    throw new Error("useConfiguracionInicial debe utilizarse dentro de ConfiguracionInicialProvider.");
  }
  return contexto;
};
